import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { certificationsData } from '../data/certifications';
import { CertificationCard } from '../components/CertificationCard';
import { PartnerCTA } from '../components/PartnerCTA';
export function WhatWeDoPage() {
  const featureBlocks = [{
    title: 'Trusted & Tailored',
    image: 'https://images.unsplash.com/photo-1580894894513-541e068a3e2b?w=800&q=80',
    copy: 'We hold comprehensive experience in government contracts, private tenders and specialist equipment procurement by working collaboratively with clients to design, develop and deliver dependable solutions.'
  }, {
    title: 'Protective Gear',
    image: 'https://images.unsplash.com/photo-1579912437766-7896df6d3cd3?w=800&q=80',
    copy: "Chiltern Global's team consists of former police, security and military professionals which provides us with experience of field conditions, innovation and end user needs; therefore, enabling us to select and audit trusted manufacturing partners and ensure every product we create, meets the levels of quality, durability and compliance, beyond the requirements."
  }, {
    title: 'Global Excellence',
    image: 'https://images.unsplash.com/photo-1544027993-37dbfe43562a?w=800&q=80',
    copy: "Concept and prototyping to production and delivery- Chiltern Global manages every step of the process, insuring adherence to technical specifications, industry certifications and international defence standards. We pride ourselves on providing our clients with reliable equipment that's built for performance and longevity."
  }, {
    title: 'Defence Procurement',
    image: 'https://images.unsplash.com/photo-1617791160505-6f00504e3519?w=800&q=80',
    copy: 'With a highly experienced research and development team using innovative technologies Chiltern Global designs, develops and manufactures a comprehensive range of specialist textile products. This includes clothing, footwear, bags, backpacks, outdoor sleeping systems, load carriage, ballistic, riot, CBRN and other specialist protective equipment.'
  }, {
    title: 'Police Frameworks',
    image: 'https://images.unsplash.com/photo-1557862921-37829c790f19?w=800&q=80',
    copy: 'With a highly experienced research and development team using innovative technologies Chiltern Global designs, develops and manufactures a comprehensive range of specialist textile products. This includes clothing, footwear, bags, backpacks, outdoor sleeping systems, load carriage, ballistic, riot, CBRN and other specialist protective equipment.'
  }];
  const partners = [{
    name: 'Make UK Defence',
    url: 'https://www.makeuk.org/about/make-uk-defence',
    logo: 'https://cdn.magicpatterns.com/uploads/cfP4ywzNizUEjpNhgJmApG/Make_UK_Defence_Logo_Col_72dpi_002_002.png'
  }, {
    name: 'Cyber Essentials Plus',
    logo: 'https://cdn.magicpatterns.com/uploads/13vUPeUkJ8i5oDWP9yZJcD/cyberessentials_certification-mark-plus_colour.png'
  }, {
    name: 'ISO 9001:2015',
    logo: 'https://cdn.magicpatterns.com/uploads/du9xSAnpmrfhYGmqcMzu2B/UKAS_9001.png'
  }, {
    name: 'ISO 14001:2015',
    logo: 'https://cdn.magicpatterns.com/uploads/c6RGX87GDb7n4CWSe5fWPD/ISO_140001.png'
  }, {
    name: 'JOSCAR',
    logo: 'https://cdn.magicpatterns.com/uploads/byihqp9gceccmuWddiSZfV/Joscar.png'
  }];
  return <>
      {/* 1. HERO BANNER */}
      <PageHero label="About Us" title="What We Do" subtitle="Over 20 years of expertise in manufacturing. We are suppliers to international defence contracts, and major police and prison forces. Through our UK based assembly line and vetted global partners, we provide high quality equipment to the defence, police, prison and medical sectors." backgroundImage="https://images.unsplash.com/photo-1579912437766-7896df6d3cd3?w=1600&q=80" data-id="element-1539" />

      {/* CTA Row Below Hero */}
      <div className="bg-navy-900 py-6 border-b border-white/5" data-id="element-1540">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1541">
          <Link to="/contact" className="inline-flex items-center justify-center px-10 py-4 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm transition-colors" data-id="element-1542">
            Contact for More
          </Link>
        </div>
      </div>

      {/* 2. BREADCRUMBS */}
      <Breadcrumbs items={[{
      label: 'About Us',
      to: '/about'
    }, {
      label: 'What We Do'
    }]} data-id="element-1543" />

      {/* 3. INTRO CONTENT SECTION */}
      <section className="bg-white py-24" data-id="element-1544">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1545">
          <h2 className="text-3xl font-bold text-navy-900 mb-6" data-id="element-1546">What We Do</h2>
          <p className="text-lg text-steel-600 leading-relaxed max-w-4xl" data-id="element-1547">
            Chiltern Global is a leading UK manufacturer, recognised for
            supplying equipment to the police, military, security and medical
            sectors. As a company, provide Custom manufacturing solutions
            tailored to meet strict operational standards of the law
            enforcement, security organisations and armed forces globally.
          </p>
        </div>
      </section>

      {/* 4. FEATURE BLOCKS SECTION */}
      <section className="bg-slate-50 py-24 border-t border-steel-200" data-id="element-1548">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1549">
          <span className="text-cg-orange-600 font-bold uppercase tracking-widest text-sm mb-2 block" data-id="element-1550">
            Our Capabilities
          </span>
          <h2 className="text-3xl font-bold text-navy-900 mb-16" data-id="element-1551">
            Military & Protective Textiles
          </h2>

          <div className="space-y-20" data-id="element-1552">
            {featureBlocks.map((block, index) => {
            const isEven = index % 2 !== 0; // 0-indexed, so 1, 3 are 'even' visually
            return <div key={index} className={`flex flex-col ${isEven ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-center`} data-id="element-1553">
                  <div className="w-full lg:w-1/2 aspect-[4/3] overflow-hidden rounded-sm" data-id="element-1554">
                    <img src={block.image} alt={block.title} className="w-full h-full object-cover" data-id="element-1555" />
                  </div>
                  <div className="w-full lg:w-1/2" data-id="element-1556">
                    <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-1557">
                      {block.title}
                    </h3>
                    <p className="text-steel-600 leading-relaxed" data-id="element-1558">
                      {block.copy}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>

      {/* 5. CERTIFICATIONS & ACCREDITATIONS SECTION */}
      <section className="bg-white py-20 border-t border-steel-200" data-id="element-1559">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1560">
          <span className="text-cg-orange-600 font-bold uppercase tracking-widest text-sm mb-2 block" data-id="element-1561">
            Our Credentials
          </span>
          <h2 className="text-3xl font-bold text-navy-900 mb-12" data-id="element-1562">
            Certifications & Accreditations
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1563">
            {certificationsData.map(card => <CertificationCard key={card.id} card={card} data-id="element-1564" />)}
          </div>
        </div>
      </section>

      {/* 6. CTA SECTION */}
      <PartnerCTA data-id="element-1565" />
    </>;
}